var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 pr-under-md-0 pl-under-md-0"
    },
    [
      _c(
        "div",
        { staticClass: "col-12 pl-0 pr-0 mb-1" },
        [
          _c(
            "b-form",
            { staticClass: "d-flex w-100" },
            [
              _c(
                "b-input-group",
                {
                  staticClass: "mb-2 w-100 annonce-create-search-bar",
                  attrs: { size: "sm" }
                },
                [
                  _c(
                    "b-input-group-append",
                    [
                      _c(
                        "b-input-group-text",
                        { staticClass: "search-input-append" },
                        [
                          _c("i", {
                            staticClass: "ph-custom ph-magnifying-glass"
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "search-input",
                    class: { active: _vm.searchInput },
                    attrs: {
                      type: "search",
                      maxlength: "250",
                      placeholder: _vm.$t("Research")
                    },
                    model: {
                      value: _vm.searchInput,
                      callback: function($$v) {
                        _vm.searchInput = $$v
                      },
                      expression: "searchInput"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectedVehicleType.invalidFeedback
        ? _c(
            "div",
            { staticClass: "d-block col-12 pl-0 pr-0 invalid-feedback mb-2" },
            [_vm._v(_vm._s(_vm.selectedVehicleType.invalidFeedback))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.filteredVehicleTypes.length !== 0 && !_vm.isLoadingVehicles,
              expression:
                "filteredVehicleTypes.length !== 0  && !isLoadingVehicles"
            }
          ],
          staticClass: "item-container-annonce styled-scrollbar-custom",
          attrs: { id: "annonce-create-items-list" }
        },
        [
          _c(
            "div",
            { attrs: { id: "annonce-create-items-list-around" } },
            [
              _c(
                "transition-group",
                {
                  staticClass: "item-container-annonce",
                  attrs: {
                    name: "listCustomTransition",
                    tag: "div",
                    id: "annonce-create-items-list-inside"
                  }
                },
                _vm._l(_vm.filteredVehicleTypes, function(vehicleType) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.filteredVehicleTypes.length > 0,
                          expression: "filteredVehicleTypes.length > 0"
                        }
                      ],
                      key: vehicleType.id,
                      staticClass: "item-annonce cursor-pointer",
                      class: {
                        "item-active":
                          _vm.selectedVehicleType.value === vehicleType.id,
                        "item-invalid": _vm.selectedVehicleType.invalidFeedback
                      },
                      on: {
                        click: function($event) {
                          return _vm.setSelectedVehicleType(vehicleType)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center align-items-center text-center"
                        },
                        [_vm._v(_vm._s(vehicleType.name))]
                      )
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.filteredVehicleTypes.length === 0 && !_vm.isLoadingVehicles,
              expression:
                "filteredVehicleTypes.length === 0  && !isLoadingVehicles"
            }
          ],
          staticClass: "w-100 styled-scrollbar-custom",
          attrs: { id: "annonce-create-items-list-empty" }
        },
        [
          _c("div", { staticClass: "empty-state-container" }, [
            _c(
              "div",
              {
                staticClass: "text-center pb-2",
                attrs: { id: "empty-state-container-img-part" }
              },
              [
                _c("img", {
                  staticClass: "empty-state-img",
                  attrs: {
                    src: require("@/assets/images/b122/img-confused.png"),
                    alt: "no result"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "text-center no-result-text",
                attrs: { id: "empty-state-container-text-part" }
              },
              [
                _c("div", { staticClass: "no-result-title mb-2" }, [
                  _vm._v(_vm._s(_vm.$t("annonce.empty.vehicleType.emptyTitle")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "no-result-subtitle my-2" }, [
                  _vm._v(_vm._s(_vm.$t("annonce.empty.vehicleType.emptyText")))
                ])
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isLoadingVehicles,
              expression: "isLoadingVehicles"
            }
          ],
          staticClass: "w-100 styled-scrollbar-custom",
          attrs: { id: "annonce-create-items-list-loading" }
        },
        [
          _c(
            "div",
            { staticClass: "w-100 d-flex justify-content-center mt-4" },
            [_c("b-spinner", { staticClass: "list-spinner" })],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6415749f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6415749f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnonceCreate/AnnonceCreateStep1.vue
// module id = igoJ
// module chunks = 0